import Vue from 'vue'
import VueRouter from 'vue-router'

// plugin
import store from '../store/index.js'

// admin
import UploadCsv from '../pages/admin/upload_csv'

// pages
import PropertyCondition from '../pages/property/property_condition'
import PropertyFavoriteList from '../pages/property/favorite_list'
import MyPage from '../pages/property/mypage'
import Login from '../pages/auth/Login'
import Secret from '../pages/auth/Secret'
import Register from '../pages/auth/Register'
import Activate from '../pages/auth/Activate'
import RequestResetPassword from '../pages/auth/RequestResetPassword'
import UpdatePassword from '../pages/auth/UpdatePassword'

// pay
import SelectPay from '../pages/pay/Select'
import SuccessPay from '../pages/pay/Success'
import Paypal from '../pages/pay/Paypal'

//////////////////////////////
// PROPERTY
import PropertyDetail from '../pages/property/detail'

Vue.use(VueRouter)

// TODO: わかりやすいように分ける
const routes = [
    {
      path: '/',
      name: 'top',
      component: PropertyCondition
    },
    {
      path: '/detail/:id',
      name: 'property-detail',
      component: PropertyDetail
    },
    {
      path: '/favorites',
      name: 'favorite-list',
      component: PropertyFavoriteList
    },
    {
      path: '/mypage',
      name: 'mypage',
      component: MyPage
    },
    {
      path: '/admin/upload/properties',
      name: 'csvUpload',
      component: UploadCsv,
      meta: { requiresAuth: true, onlyAdmin: true },
    },
    {
      path: '/auth/secret',
      component: Secret,
      name: 'secret'
    },
    {
      // LINEブラウザの場合、Oauth認証が上手く処理されないので外部ブラウザに飛ばす様にする。
      // パラメーターはLineの仕様
      path: '/auth/login',
      component: Login,
      name: 'login',
      meta: { onlyGuest: true },
    },
    {
      path: '/auth/register',
      component: Register,
      name: 'register',
      meta: { onlyGuest: true },
    },
    {
      path: '/auth/activate',
      component: Activate,
      name: 'activate'
    },
    {
      path: '/auth/requestResetPassword',
      component: RequestResetPassword,
      name: 'requestResetPassword',
      meta: { onlyGuest: true },
    },
    {
      path: '/auth/updatePassword',
      component: UpdatePassword,
      name: 'updatePassword',
      meta: { onlyGuest: true },
    },
    /** 決済処理 */
    {
      path: '/pay/select',
      name: 'pay-select',
      component: SelectPay,
      meta: { requiresAuth: true }
    },
    {
      path: '/pay/success',
      name: 'pay-success',
      component: SuccessPay,
      meta: { requiresAuth: true }
    },
    {
      path: '/pay/paypal',
      name: 'pay-paypal',
      component: Paypal,
      meta: { requiresAuth: true }
    },
    {
      path: '*',
      redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
})


// 管理者ページには管理者のみアクセスできる
// 認証系のページにはゲストのみがアクセスできる
router.beforeEach(async (to, from, next) => {

  // 管理者専用ページに管理者以外は遷移できない
  if (to.matched.some(record => record.meta.onlyAdmin) && store.getters['auth/getRole'] == 'user') {
    next({ name: 'top' })
  }

  // ログイン済みユーザーのログイン画面への遷移を防ぐ
  else if (to.matched.some(record => record.meta.onlyGuest) && store.state.auth.isLoggedIn) {
    next({ name: 'pay-select' })
  }

  // 購入済みユーザーはキー認証画面に遷移させない
  else if (to.path === '/pay/select') {
    await store.dispatch('auth/checkAuthed')

    if (store.state.auth.user && store.state.auth.user.is_reach) {
      next({ name: 'top' })
    }
  }
  
  next()

})


export default router